/*  
depends on jquey and Knockout
*/
'use strict';
var orderForm = orderForm || {};

/**
 * function responsible for knockout viewmodel rendering, 
 * this function must be called after all jquery and its plugin
 * @param op option object with data 
 */
var knockoutOrderFormData ;
orderForm.orderFormView = function(op) {
    function Product(data) {
        var self = this;
        var changeQty=false;
        self.offerPackageId = ko.observable(data.funnel_offer_package_id);
        self.productLabel = ko.observable(data.product_label);
        self.productDescription = ko.observable(data.product_description);

        self.addAutoOrderProduct=ko.observable(false);
        if( typeof SHOW_AUTO_OPTION!=='undefined'){
            if(AUTO_OPTION_PRODUCT_ID==data.product_id){
                if(SHOW_AUTO_OPTION===1){
                    self.showAutoOrderOption=ko.observable(1);
                }
                else{
                    self.showAutoOrderOption=ko.observable(0);
                    self.addAutoOrderProduct=ko.observable(true);
                }
               
            }
            else{
                self.showAutoOrderOption=ko.observable(0); 
            }
        }
        else{
            self.showAutoOrderOption=ko.observable(0);
        }
        

       // self.totalValue = ko.observable(data.total_value);
        self.totalValue=   ko.computed(function () {
             //reduce grand total from subscrition
             let totalValue = data.total_value;
             if(typeof  data.multibuy_offer!=='undefined' && data.multibuy_offer!=null && data.multibuy_offer.length>1 ){
               
                    JSON.parse(data.multibuy_offer).forEach(function(element,index){
                        var qtyid='#qty';
                        if($(qtyid+data.product_id).length){
                            qtyid = qtyid+data.product_id;
                        }
                        if($(qtyid).length&&element.qty==$(qtyid).val() && element.price>0){
                         changeQty=true;
                         totalValue = element.qty*element.price;
                         if(self.addAutoOrderProduct()===true){
                            var subItemPrice = parseFloat((element.price- element.price* SUBSCRIPTION_DISCOUNT  /100).toFixed(2));
                             totalValue=  element.qty*subItemPrice;
                           }
                        }
                        
                       
                     });
                     if(!$('#qty'+data.product_id).length){
                         if(self.addAutoOrderProduct()===true){
                             return totalValue - (totalValue* SUBSCRIPTION_DISCOUNT  /100);
                         }
                     }
                    
     
                 }
                 else{
                     if(self.addAutoOrderProduct()===true){
                         return totalValue - (totalValue* SUBSCRIPTION_DISCOUNT  /100);
                     }
                 }
          
          
            return totalValue;
        });
       
        if($('#qty').length && $('#qty').val()!=''){
            if(changeQty){
                self.qty = ko.observable($('#qty').val());
            }
            else{
                self.qty = ko.observable(data.qty);
            }
           
        }
        else if($('#qty'+data.product_id).length && $('#qty'+data.product_id).val()!=''){
            self.qty = ko.observable($('#qty'+data.product_id).val());
        }
        else{
            self.qty = ko.observable(data.qty);
        }
      
        self.id = ko.observable(data.product_id);
        self.retailPrice = ko.computed(function () {
            return formatTotal((data.retail_price * self.qty()));
        });
        self.imageThumb =ko.observable(data.media_info.thumb);
        self.isHidden =ko.observable(data.is_hidden);
        self.shippingDelay =ko.observable(data.shipping_delay);
       

        self.checkoutBump =ko.observable(data.checkout_bump);
        self.addCheckoutBump=ko.observable(false);
        self.discountPercent = ko.computed(function(){
            var discount = Math.round(((self.retailPrice()-self.totalValue())*100)/self.retailPrice());
            if(discount<0){
                return 0;
            }
            else{
                return discount;
            }
       
        });
        self.showInSummary =ko.computed(function () {
            if(self.checkoutBump()=='1'){
                if(self.addCheckoutBump()===true)
                return true;
                return false;
            }
            else{
                return true;
            }
        });

        self.bannerSaveAmount = ko.computed(function () {

        });
     
    }
    function shippingMethod(data){
        var self = this;
        self.title =  ko.observable(data.title);
        self.cost =  ko.observable(data.cost);
        self.logoUrl=  ko.observable(data.logoUrl);
        self.type =  ko.observable(data.type);
        if(data.enableCountry){
            self.enableCountry=  ko.observable(data.enableCountry);
        }
        else{
            self.enableCountry= ko.observable('all');
        }
      
    }
    function couponCodes(data){
        var self = this;
        if(data.valid!==false){
            self.name = data.name;
            self.type= data.type;
            self.discount= data.discount;
        }
       
        self.valid = data.valid;
     }
    function orderFormViewModel() {
        var self = this
        self.email =  ko.observable($('#email').val());
        self.funneOfferPackageId = ko.observable($('[name="funnel_offer_package_id"]').val())
        if($('#full_name').val()!=''|| $('#full_name').val()!=='undefined'){
            self.fullName =  ko.observable($('#full_name').val()).trimmed();
        }
        else{
            self.fullName = ko.observable();
        }
        
        self.firstName =  ko.computed(function(){
            if(self.fullName()!=''||self.fullName()!=='undefined'){
            return self.fullName().split(' ').slice(0,-1).join(' ');
            }
        });
        self.lastName =  ko.computed(function(){
            if(self.fullName()!=''||self.fullName()!=='undefined'){
                return self.fullName().split(' ').slice(-1).join(' ');
            }
            
        });
        if($('input[name="qty"]').length && $('input[name="qty"]').val()!=''){
            self.qty = ko.observable($('input[name="qty"]').val());
        }
        self.phone =  ko.observable($('#phone').val());
        self.address =  ko.observable($('#address').val());
        self.countryId =  ko.observable($('#country_id').val());
        self.state =  ko.observable($('#state').val());
        self.postCode =  ko.observable($('#billingpostcode').val());
        self.city =  ko.observable($('#city').val());
        self.cardName =  ko.observable($('#card_name').val());
        self.cardNumber =  ko.observable($('#card_number').val());
        self.cardMonth =  ko.observable($('#card_month').val());
        self.cardYear =  ko.observable($('#card_year').val());
        self.cardSecureCode =  ko.observable($('#card_secure_code').val());
        if($('#shipping_same').is(":checked")){
            self.shippingSame= ko.observable(true);
        }
        else{
            self.shippingSame=ko.observable(false);
        }
        //shipping info if differnt 

        self.shipFullName = ko.observable($('#ship_full_name').val()).trimmed();
        self.shipFirstName =  ko.computed(function(){
            return self.fullName().split(' ').slice(0,-1).join(' ');
        });
        self.shipLastName =  ko.computed(function(){
            return self.fullName().split(' ').slice(-1).join(' ');
        });
        self.shipEmail = ko.observable($('#ship_email').val());
        self.shipPostCode = ko.observable($('#ship_postcode').val());
        self.shipCity = ko.observable($('#ship_city').val());
        self.shipAddress1 = ko.observable($('#ship_address1').val());
        self.shipCountryId = ko.observable($('#ship_country_id').val());
        self.shipState = ko.observable($('#ship_state').val());
       
        self.products = ko.observableArray([]);
        self.checkoutCouponCode = ko.observable($('#checkout-coupon-code').val());
        self.totalValue = ko.observable(0);
        self.shippingMethod = ko.observableArray([]);
        self.couponCodes = ko.observableArray([]);
        if($('#session_shipping_method').val()!==undefined){
            self.sessionShippingMethod=ko.observable($('#session_shipping_method').val());
        }
        else{
            self.sessionShippingMethod=ko.observable('');
        }
        if(self.sessionShippingMethod()!== undefined && self.sessionShippingMethod()!=''){
            self.selectedShippingMethod=ko.observable(self.sessionShippingMethod());
        }
        else{
            self.selectedShippingMethod=ko.observable('default');
        }
        self.showShippingMethod = ko.computed(function(){
            //check if additional shipping is enable for the offer package
            var show = false;
            if (self.products().length > 0) {
                self.products().forEach(function (item, index) {
                    if(item.offerPackageId()==44||item.offerPackageId()==45){
                        show=true;
                    }
                });
            }
            if(show==false){
                return false;
            }
            if(self.shippingSame()===false){
                return (self.shipCountryId()=='US')?true:false;
            }
            return (self.countryId()=='US')?true:false;
        });
        
        self.shippingCost = ko.computed(function () {
          var selectedCost=  getSelectedShippingMethodCost();
            if(self.shippingSame()===false){
                if (op.shippingInfo.freeCountry.indexOf(self.shipCountryId()) !== -1){

                    return (selectedCost===0)?0:formatTotal(selectedCost);
                }
                else{
                    return formatTotal(op.shippingInfo.shippingCost);
                }
            }
            if (op.shippingInfo.freeCountry.indexOf(self.countryId()) !== -1) {
                return (selectedCost===0)?0:formatTotal(selectedCost);
            }
            else {
                return formatTotal(op.shippingInfo.shippingCost);
            }
        })
        //map the data with jason response
        mapProduct(op.offterItemList);
        mapshippingMethod(op.shippingInfo.shippingMethod);
        //mapCouponCodes([]);
      console.log(self.checkoutCouponCode());
       console.log(self.funneOfferPackageId()); 
       // mapCouponCodes([{"name":"test","type":"percent","discount":10,"valid":true}]);
       if(self.checkoutCouponCode()!='')
            checkCouponCodeValid();
    
        function checkCouponCodeValid(callback){
            $.post(BASE_URL+"checkout/couponpost",{couponCode:self.checkoutCouponCode(),funneOfferPackageId:self.funneOfferPackageId()
            }).done(function(data){
                mapCouponCodes(data);
                if(typeof callback === 'function'){
                    callback(data);
                }
                  
            });
        }
        self.selectedShippingMethodTitle = ko.computed(function () {
           var info = {
               title:'',
               logo:'',
           }
            if (self.shippingMethod().length > 0) {
            self.shippingMethod().forEach(function (item, index) {
                if(self.selectedShippingMethod()==item.type()){
                    info.title= item.title();
                    info.logo= item.logoUrl();

                }
                   

            });
        }
      
        return info;
     
        });
        self.routeCost=ko.observable(0);
        self.routeOriginalCost=0;
        self.routeToggleState=ko.observable(1);
        //get routecost
        if(typeof window.Route!=='undefined'){
        window.Route.Protection.on("get_quote", function (event) {

            self.routeCost(event.quote.premium.amount);
            self.routeOriginalCost=event.quote.premium.amount;
            $('#routeProtectionCost').val(self.routeOriginalCost);
        });
        window.Route.Protection.on("status_change", function (event) {
            self.routeToggleState(event.to);
            if(event.to===0){
                self.routeCost(0);
                $('#routeProtectionCost').val(0)
            }
            else{
                $('#routeProtectionCost').val(self.routeOriginalCost);
                self.routeCost(self.routeOriginalCost);
            }
        });
    }
    
        self.couponCodeDiscountValue = ko.computed(function(){
            var discountValue = 0; 
            if(self.couponCodes().length>0){
                self.couponCodes().forEach(function (item, index) {
                    if(item.valid ===false){
                        discountValue=0;
                    }else{
                        if(item.type=='amount'){
                            discountValue = item.discount;
                        }
                        else{
                            if(typeof item.discount!=='undefined')
                            discountValue =self.totalValue()*item.discount/100;
                        }
                    }
                   
                  
                   
                });
            }
            return formatTotal(discountValue);
        });
        self.grandTotal = ko.computed(function () {
            var grandtotal = 0;
            if (self.products().length > 0) {
                self.products().forEach(function (item, index) {
                    if(item.shippingDelay()<1){
                        if(item.checkoutBump()!='1'){
                            grandtotal = grandtotal + item.totalValue();
                        }
                        if(item.checkoutBump()=='1'&&item.addCheckoutBump()===true){
                            grandtotal=grandtotal+item.totalValue();
                        }
                    } 
                });
            }
            self.totalValue(grandtotal);
            if(typeof window.Route!=='undefined'){
                initRouteWidget(grandtotal-self.couponCodeDiscountValue())
            }
            return formatTotal(grandtotal + self.routeCost()+ formatTotalDecimal(self.shippingCost())-formatTotalDecimal(self.couponCodeDiscountValue()));
        });
     
      
        self.applyCouponCode = function(data,event){
            checkCouponCodeValid(function(data){
                console.log(data);
                if(data[0].valid ==true){
                    $('#coupon-code-success').show();
                    $('#coupon-code-error').hide();
                }
                else{
                    $('#coupon-code-success').hide();
                    $('#coupon-code-error').show();
                }
            });
         
        }
        self.cancelCouponCode = function(data,event){
            $.post(BASE_URL+"checkout/couponpost?cancel=1",{couponCode:self.checkoutCouponCode(),funneOfferPackageId:self.funneOfferPackageId()
            }).done(function(data){
                mapCouponCodes(data);
                $('#checkout-coupon-code').removeAttribue('readonly');
            });
        }
        function mapProduct(datas) {
            var productsMap = $.map(datas, function (item) {
                return new Product(item);
            });
            self.products(productsMap);
            console.log(productsMap);
        }

        function mapshippingMethod(datas) {
            var mapShipping = $.map(datas, function (item) {
               return new shippingMethod(item);
            });
           
            self.shippingMethod(mapShipping);
        }
        function mapCouponCodes(datas){
            var mapCouponCodes = $.map(datas, function (item) {
                return new couponCodes(item);
             });
             self.couponCodes(mapCouponCodes);
        }
        function getSelectedShippingMethodCost(){
            var cost =0;
            if (self.shippingMethod().length > 0) {
                self.shippingMethod().forEach(function (item, index) {
                    if(self.selectedShippingMethod()==item.type()){
                        cost= item.cost();
                    }
                       
    
                });
            }
            return cost;
        }
    
        self.countryChange = function (data, event) {
            // data.shipping.shippingCost(op.shipping)
        }
        self.placeOrder= function (data,event){
            knockoutOrderFormData= ko.toJS(orderFormViewModel);
           // console.log(knockoutOrderFormData);
           return true;
        }

    }
    function formatTotalDecimal(num) {
        if (num.isInteger) {
            return parseFloat(num.toFixed(2));
        }
        return parseFloat(num);

    }
    function formatTotal(num) {
        return parseFloat(num.toFixed(2));
        //return round_up(num,2);
    }
    ko.subscribable.fn.trimmed = function() {
        return ko.computed({
            read: function() {
                if(this()!=='undefined'){
                   return this();
                }
               
              
            },
            write: function(value) {
                if(value!=''||value!=='undefined'){
                    this(value.trim());
                }
                this.valueHasMutated();
            },
            owner: this
        });
    };
  
    var orderFormViewModel = new orderFormViewModel();
    ko.applyBindings(orderFormViewModel);
  
    setTimeout(function() {
        $('#checkout-bumb-wrapper').show();
        $('.subscription-option-wrapper').show();
     }, 200);
};
/**
 * function that hide and shows element based on checkobox click
 * @param op object 
 */
orderForm.toggleChecked = function(op) {

    $(document).on('change',op.checkedElement, function () {
        if ($(op.checkedElement).is(':checked')) {
            $(op.targetElement).hide();
        }
        else {
            $(op.targetElement).show();
        }
    });
    if ($(op.checkedElement).is(':checked')) {
        $(op.targetElement).hide();
    }
    else {
        $(op.targetElement).show();
    }

};
/**
 * function that hide and shows element
 * @param op object 
 */
orderForm.collapse = function(op) {

    $(document).on('click',op.element, function () {
        if($(this).hasClass('expanded'))
        {
            if(op.trarget){
                $(op.trarget).hide();
                $(this).removeClass('expanded');
            }
            else{
                $(this).next().hide();
                $(this).removeClass('expanded');
            }
        }
        else{
            if(op.trarget){
                $(op.trarget).show();
                $(this).addClass('expanded');
            }
            else{
                $(this).next().show();
                $(this).addClass('expanded');
            }
        }
        
    });
};
/**
 * function that can be used for tooltip or toggle the target element with action toggle.
 * @param op 
 */
orderForm.toolTip = function(op){
    var targetElement;
    $(document).on('click',op.element, function () {
        targetElement = $(this).data('target');
        if(op.target)
        {
            targetElement=op.target; 
        }
        if(op.action=='toggle'){
            if($(this).hasClass('active')){
                $(targetElement).hide();
                $(targetElement).removeClass('active');
                $(this).removeClass('active')
            }
            else{
                $(targetElement).show();
                $(this).addClass('active')
                $(targetElement).addClass('active');
            }
        }
        else{
            $(targetElement).show();
        }
    });
    if(op.targetCloseElement){
        $(document).on('click',op.targetCloseElement, function () {
            $(op.target).hide();
        });
    }
    if(op.targetCloseOnClick===true){
        $(document).on('click',op.target, function () {
            $(this).hide();
        });
    }
};
/**
 * function that add the hident input element
 * @param Object op 
 * 
 */
orderForm.addClientInfo = function(op) {
    function createHiddenInput(form, name, value) {
        var input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", name);
        input.setAttribute("value", value);
        form.appendChild(input);
    }
    var myForms = document.getElementsByName(op.formName);
    if (myForms != null && myForms.length > 0) {
        for (var i = 0; i < myForms.length; i++) {
            var myForm = myForms[i];
            createHiddenInput(myForm, "browser_color_depth", screen.colorDepth);
            createHiddenInput(myForm, "browser_java_enabled", navigator.javaEnabled());
            createHiddenInput(myForm, "browser_language", navigator.language);
            createHiddenInput(myForm, "browser_screen_height", screen.height);
            createHiddenInput(myForm, "browser_screen_width", screen.width);
            createHiddenInput(myForm, "timezone", new Date().getTimezoneOffset()/60);
        }
    }
};
/**
 * function to subscribe cart abandonment
 * @param mp email marking provider 
 */
orderForm.subscribeToCartAbandonmentList = function(mp){
    var camp,ev, em, email_added=0, provider='klaviyo';
    if (typeof mp!=='undefined'){
        provider=mp;
    }
    camp = $('input[name="cart_abandonment_list"]').val();// define the campaign value here
    ev = $('input[name="cart_abandonment_event"]').val();
    $(document).on("change", "#email", function () {
        if(email_added===1)
        return;
        em = $('#email').val();
        if (IsEmail(em)) {
            $.ajax({
                type: "POST",
                url: BASE_URL + 'emailsubscribe',
                data: { email: em, campaign: camp,mprovider:provider,event:ev },
                success: function (data) {
                    email_added=1;
                    console.log(data);
                }
            });
        }
    });
};
orderForm.subscribeWithYoag2 = function(level){
    var step;
    if (typeof level==='undefined'){
        step=1;
    }
    else{
        step= level;
    }
    var em,campaign,email_added=0;
          campaign = $('input[name="pcid"]').val();
          em=$('#email').val();
          if(IsEmail(em) && !email_added && step===2){
            email_added = 1;
            bensapi.startFunnel(em, campaign,step);
          }
        $(document).on("change", "#email", function () {
            em = $('#email').val();
            if (IsEmail(em) && !email_added) {
                email_added = 1;
                bensapi.startFunnel(em, campaign,step);
                console.log("Start: " + em);
            }
        });
};
/** 
 * funciton to save form data to sessionStorage and update when reloaded
 */

orderForm.getSessionStorage=function(formElement){
    $(document).on('change', formElement, function() {
        if($(this).is(':radio')){
            //ignore radio
        }
        else{
            if($(this).is(':checkbox')&& !($(this).is(':checked'))){
                if($(this).attr('name')=='shipping_same'){
                    sessionStorage.setItem($(this).attr('name'), 'off');
                }
                else{
                    sessionStorage.removeItem($(this).attr('name'));
                }
               
            }
            else{
                if($(this).attr('name')=='full_name'){
                    sessionStorage.setItem($('#first_name').attr('name'), $('#first_name').val());
                    sessionStorage.setItem($('#family_name').attr('name'), $('#family_name').val());
                }
                sessionStorage.setItem($(this).attr('name'), $(this).val());
            }
            
        }
        
    });
    //get the value 
    $(formElement).each(function() {
        
       let sessionValue = sessionStorage.getItem($(this).attr('name'));
        if(sessionValue){
            if($(this).is(':checkbox')){
                if(sessionValue==1 || sessionValue=='on'){
                 $(this).prop( "checked", true );
                }
                else{
                    $(this).removeAttr('checked');
                  $(this).prop( "checked", false ).removeAttr('checked');;
                }
             }
             else{
                 if($(this).is(':radio')){
                   //  ignore the radio for now 
                 }
                 else{
                    $(this).val(sessionValue);
                 }
                 
             }
        }
        //save the shipping same value in session by default
       
      
    });
   
}
/**
 * Depends of jquery.steps http://www.jquery-steps.com/
 * Add step to checkout page 
 */
jQuery.validator.addMethod('fullname', function(value, element) {
    if (/^([a-zA-Z\.]{0,}\s[a-zA-z\.]{0,}'?-?[a-zA-Z]{0,}\s?([a-zA-Z]{0,})?)/.test(value)) {
      return true;
    } else {
      return false;
    };
  }, 'Please enter your full name.');
  jQuery.validator.addMethod('exp', function(value, element) {
    var minMonth = new Date().getMonth() + 1;
    var minYear = new Date().getFullYear();
    var month = parseInt(value, 10);
    var year = parseInt($('#card_year').val(), 10);
    return (!month || !year || year > minYear || (year === minYear && month >= minMonth));
  }, 'Expiration Date can not be in past.');

orderForm.onSubmitFrom = function(orderFormElement) {
    $(orderFormElement).validate({
        submitHandler: function (form) {
            if(typeof Frames!=='undefined'){
                Frames.submitCard();
                if(Frames.isCardValid()){
                    showLoading();
                }
            }
            else{
                showLoading();
                form.submit();
            }
           
        },
    });
    function showLoading(){
        $("input[type='submit']").val("Please Wait...").attr('disabled',
        'disabled');
    if($('#spinner-icon').length>0){
        $('#spinner-icon').show();
    }
    }
};
orderForm.printState = function(op,isChanged) {
    var stateValue = op.stateValue;
    var us_state_name = ["Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
        "Delaware", "District of Columbia", "Federated states of micronesia", "Florida", "Georgia", "Guam", "Hawaii", "Idaho",
        "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Marshall islands", "Maryland",
        "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
        "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Northern Mariana Islands", "Ohio",
        "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico", "Rhode Island", "South Carolina", "South Dakota",
        "Tennessee", "Texas", "Utah", "Vermont", "Virgin Islands", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming", "Armed Forces AA", "Armed Forces AE", "Armed Forces AP"];
    var select_state = '<option value="">--Please Select--</option>';
    for(var i = 0; i < us_state_name.length; i++) {
        if(isChanged===true){
            stateValue =   document.getElementById(op.stateFieldId).value;
        }
        if (us_state_name[i]==stateValue) {
                select_state =  select_state+'<option value="' + us_state_name[i] +'" Selected>' + us_state_name[i] + '</option>';
        }
        else{
            select_state = select_state + '<option value="' + us_state_name[i] +'">' + us_state_name[i] + '</option>';
        }
        
    }
    if($(op.countryElement).val()=='US'){
        document.getElementById(op.stateFieldId).innerHTML = select_state;
    }
    orderForm.onChangeCountry(op);
   
};
orderForm.createHiddenInput = function(op) {
    var input = document.createElement("input");
    input.setAttribute("type", "hidden");
    input.setAttribute("name", op.name);
    input.setAttribute("value", op.value);
    formElementId.appendChild(input);
};

orderForm.onChangeCountry = function (op) {
   
    $(document).on('change',op.countryElement, function (event) {
        op.stateValue='';
        orderForm.printState(op,true);
    });

};
function addressAutoFill(){
     // This sample uses the Autocomplete widget to help the user select a
    // place, then it retrieves the address components associated with that
    // place, and then it populates the form fields with those details.
    // This sample requires the Places library. Include the libraries=places
    // parameter when you first load the API. For example:
    // <script
    // src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">
    
    var placeSearch, autocomplete;

    var componentForm = {
        street_number: ['long_name','address'],
        route: ['long_name','address'],
        premise:['long_name','address'],
        locality: ['long_name','city'],
        administrative_area_level_1: ['long_name','state'],
        country: ['short_name','country_id'],
        postal_town: ['short_name','city'],
        postal_code: ['long_name','billingpostcode']
      };
    
      // Create the autocomplete object, restricting the search predictions to
      // geographical location types.
      autocomplete = new google.maps.places.Autocomplete(
          document.getElementById('address'), {types: ['geocode']});
    
      // Avoid paying for data that you don't need by restricting the set of
      // place fields that are returned to just the address components.
      autocomplete.setFields(['address_component']);
    
      // When the user selects an address from the drop-down, populate the
      // address fields in the form.
      autocomplete.addListener('place_changed', fillInAddress);
        //disable autocomplete on manual input
         
      $(document).on('click', '#manualSearch', function(){
          $(this).hide();
        $('.address-show-more').show();
        google.maps.event.clearInstanceListeners(document.getElementById('address'));

    })
    
    function fillInAddress() {
      // Get the place details from the autocomplete object.
      var place = autocomplete.getPlace();
    
      for (var component in componentForm) {
          var componetkey = componentForm[component];
          if($('#'+componetkey[1]).length>0)
            $('#'+componetkey[1]).val('');
      }
    
      // Get each component of the address from the place details,
      // and then fill-in the corresponding field on the form.
      //make address filed to set both street number and route
      var addressFull='';
      var addressFound = 0;
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (componentForm[addressType]) {
           
            var componetIdKey = componentForm[addressType];
            var addressTypeId = componetIdKey[1];

         var elementId =  $('#'+addressTypeId);
          var valplace = place.address_components[i][componetIdKey[0]];
          if(addressTypeId=='address'){
          
            addressFull= elementId.val();
            if(addressFound===0){
                elementId.val(valplace);
                addressFound++;
            }
            else{
                elementId.val(addressFull+' '+valplace);
            }
               
                elementId.trigger('change');
            
         
          }
          else{
            elementId.val(valplace);
            elementId.trigger('change');
          
          }
         
        }
      }
     
      $('.address-show-more').show();
    }

    
    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    function geolocate() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          var circle = new google.maps.Circle(
              {center: geolocation, radius: position.coords.accuracy});
          autocomplete.setBounds(circle.getBounds());
        });
      }
    }
    $(document).on('change','#address',function(){
        $('.address-show-more').show();
      });
 
}
function IsEmail(email) {
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(!regex.test(email)) {
       return false;
    }else{
       return true;
    }
  }
//addd fullname method
